__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.6.0", () => (Promise.all([__webpack_require__.e(350), __webpack_require__.e(264), __webpack_require__.e(284)]).then(() => (() => (__webpack_require__(8284))))));
			register("@emotion/styled", "11.6.0", () => (Promise.all([__webpack_require__.e(264), __webpack_require__.e(619), __webpack_require__.e(404)]).then(() => (() => (__webpack_require__(932))))));
			register("@loadable/component", "5.15.0", () => (Promise.all([__webpack_require__.e(264), __webpack_require__.e(684)]).then(() => (() => (__webpack_require__(684))))));
			register("@mui/material", "5.4.1", () => (Promise.all([__webpack_require__.e(880), __webpack_require__.e(264), __webpack_require__.e(644), __webpack_require__.e(790), __webpack_require__.e(795)]).then(() => (() => (__webpack_require__(5880))))));
			register("@mui/system", "5.4.1", () => (Promise.all([__webpack_require__.e(350), __webpack_require__.e(830), __webpack_require__.e(264), __webpack_require__.e(619), __webpack_require__.e(128), __webpack_require__.e(227)]).then(() => (() => (__webpack_require__(7830))))));
			register("@reduxjs/toolkit", "1.7.1", () => (Promise.all([__webpack_require__.e(171), __webpack_require__.e(899)]).then(() => (() => (__webpack_require__(3171))))));
			register("iconoir-react", "6.11.0", () => (Promise.all([__webpack_require__.e(462), __webpack_require__.e(264)]).then(() => (() => (__webpack_require__(462))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(264)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-redux", "7.2.5", () => (Promise.all([__webpack_require__.e(216), __webpack_require__.e(264), __webpack_require__.e(644), __webpack_require__.e(88)]).then(() => (() => (__webpack_require__(372))))));
			register("react-router-dom", "5.3.0", () => (Promise.all([__webpack_require__.e(71), __webpack_require__.e(264), __webpack_require__.e(886), __webpack_require__.e(727)]).then(() => (() => (__webpack_require__(3727))))));
			register("react-router", "5.2.1", () => (Promise.all([__webpack_require__.e(71), __webpack_require__.e(264), __webpack_require__.e(977)]).then(() => (() => (__webpack_require__(5977))))));
			register("react", "17.0.2", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			register("redux-persist", "6.0.0", () => (__webpack_require__.e(277).then(() => (() => (__webpack_require__(7277))))));
			initExternal(9657);
			initExternal(9679);
			initExternal(2935);
			initExternal(6879);
			initExternal(7856);
			initExternal(2721);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};